/**
 * Template Service
 * AIDLC Administrative Backend
 *
 * API calls for task and prompt template operations.
 * Interface matches the backend TaskTemplate schema.
 */

import apiClient from './api';

export interface TemplateStep {
  order: number;
  agentId: string;
  action: string;
  description: string;
  gate: string | null;
}

export interface TaskTemplate {
  id: string;
  name: string;
  description: string;
  category: string;
  agentIds: string[];
  steps: TemplateStep[];
  estimatedDuration: string;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

const TEMPLATES_PATH = '/templates';

export async function getAllTemplates(): Promise<TaskTemplate[]> {
  const response = await apiClient.get<TaskTemplate[]>(TEMPLATES_PATH);
  return response.data;
}

export async function getTemplateById(templateId: string): Promise<TaskTemplate> {
  const response = await apiClient.get<TaskTemplate>(`${TEMPLATES_PATH}/${templateId}`);
  return response.data;
}

export async function createTemplate(
  template: Omit<TaskTemplate, 'id' | 'createdAt' | 'updatedAt'>
): Promise<TaskTemplate> {
  const response = await apiClient.post<TaskTemplate>(TEMPLATES_PATH, template);
  return response.data;
}
